// const tenant = 'unob2c.onmicrosoft.com';

export const appConfig = {
  api: {

    apiUrl: "https://api.carrierappshub1.com/",

    // uiUrl: "https://dev.d2hor9274pjp8v.amplifyapp.com",
    uiUrl: "https://dev-automl.carrier.com",

    postLogoutRedirectUri: "http://localhost:3000",
  },
};
export default appConfig;
